import {defineField, defineType} from 'sanity'
import {VscFolderOpened} from 'react-icons/vsc'
import {count} from '@/lib/utils'

export default defineType({
  name: 'link.list',
  title: 'Link list',
  icon: VscFolderOpened,
  type: 'object',
  fields: [
    defineField({
      name: 'label',
      type: 'string',
    }),
    defineField({
      name: 'links',
      type: 'array',
      of: [{type: 'link'}, {type: 'link.list'}],
      validation: (Rule) => Rule.required().min(1),
    }),
  ],
  preview: {
    select: {
      label: 'label',
      link: 'link',
      links: 'links',
    },
    prepare: ({label, links}) => ({
      title: label,
      subtitle: count(links, 'link'),
    }),
  },
})
